import { errorText } from "./v6Api";

// 문의 화면의 쓰기 동작 공통 처리: 누가 했는지(actor) 확인, 실패해도 화면은 서버 상태로 다시 맞춘다.
export function requireActor(adminId, notify) {
    if (Number.isInteger(adminId)) return true;
    notify("관리자 탭에서 내 계정으로 전환한 뒤 처리해 주세요.", "warning");
    return false;
}

export async function runAction(fn, { ok, notify, reload }) {
    try {
        await fn();
        if (ok) notify(ok, "success");
        await reload();
        return true;
    } catch (e) {
        notify(errorText(e), "error");
        await reload();
        return false;
    }
}
